import { render, staticRenderFns } from "./RiskAnalysis.vue?vue&type=template&id=36cd50fc&scoped=true"
import script from "./RiskAnalysis.vue?vue&type=script&lang=js"
export * from "./RiskAnalysis.vue?vue&type=script&lang=js"
import style0 from "./RiskAnalysis.vue?vue&type=style&index=0&id=36cd50fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd50fc",
  null
  
)

export default component.exports